import React, { useContext, useEffect, useState } from "react"

import * as S from "./header.styles.jsx"
import CustomButton from "../custom-button/custom-button.component"
import { useMediaQuery, useScrollTrigger, useTheme } from "@mui/material"
import { graphql, useStaticQuery } from "gatsby"
import Treez from "../../assets/treez.svg"
import Add from "../../assets/add.svg"
import { colorsContext } from "../../provider"
import LogoMobile from ".././../assets/mosaic-mobile-logo.svg"
import Logo from "../../assets/mosaic-logo.svg"
import { isBrowser } from "../../utils/utils"

const Header = ({ isLightHeader, isTreezPage }) => {
  const { setIsFormDrawerOpen } = useContext(colorsContext)
  const theme = useTheme()
  const [pathName, setPathName] = useState("")
  const [classOverview, setClassOverview] = useState("")
  const isSm = useMediaQuery(theme.breakpoints.down("md"), {
    defaultMatches: true,
  })
  const scrollTrigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 102,
  })

  const staticQuery = useStaticQuery(graphql`
    query {
      headerIcon: file(relativePath: { eq: "mosaic-logo.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, quality: 100)
        }
      }
      mobileIcon: file(relativePath: { eq: "mobile-logo.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, quality: 100)
        }
      }
    }
  `)

  const onActiveLink = () => {
    setClassOverview("activeOverview")
  }

  const onInactiveLink = () => {
    setClassOverview("inactiveOverview")
  }

  useEffect(() => {
    if (isBrowser()) {
      const url = window.location
      setPathName(url.pathname)
    }
  }, [])

  return (
    <S.CustomAppBar
      elevation={0}
      className={isLightHeader && !scrollTrigger ? "light" : ""}
    >
      <S.CustomContainer maxWidth={"xl"}>
        <S.LogosWrapper>
          <S.LogoLink url={"/"}>{isSm ? <LogoMobile /> : <Logo />}</S.LogoLink>
          {isTreezPage && (
            <S.TreezLogo>
              <Add />
              <Treez className="treez" />
            </S.TreezLogo>
          )}
        </S.LogosWrapper>
        {pathName === "/" ? (
          <S.NavItems>
            <S.CustomNavLink
              activeClass="active"
              to="overview"
              spy={true}
              smooth={true}
              offset={-100}
              className={classOverview}
            >
              Overview
            </S.CustomNavLink>
            <S.CustomNavLink
              activeClass="active"
              to="overview-2"
              spy={true}
              smooth={true}
              offset={-100}
              onSetActive={() => onActiveLink()}
              onSetInactive={() => onInactiveLink()}
              className="noDisplay"
            >
              Overview
            </S.CustomNavLink>
            {!isTreezPage && (
              <S.CustomNavLink
                activeClass="active"
                to="examples"
                spy={true}
                smooth={true}
                offset={-100}
              >
                Examples
              </S.CustomNavLink>
            )}
            {isTreezPage && (
              <S.CustomNavLink
                activeClass="active"
                to="benefits"
                spy={true}
                smooth={true}
                offset={-100}
              >
                Benefits
              </S.CustomNavLink>
            )}
            <S.CustomNavLink
              activeClass="active"
              to="testimonials"
              spy={true}
              smooth={true}
              offset={-100}
            >
              Testimonials
            </S.CustomNavLink>
            {!isTreezPage && (
              <S.CustomNavLink
                activeClass="active"
                to="our-mission"
                spy={true}
                smooth={true}
                offset={-100}
              >
                Our Mission
              </S.CustomNavLink>
            )}
            <S.CustomNavLink
              activeClass="active"
              to="blog"
              spy={true}
              smooth={true}
              offset={-100}
            >
              Blog
            </S.CustomNavLink>
          </S.NavItems>
        ) : (
          <S.NavItems>
            <S.LinkWithHref
              activeClass="active"
              url="/#overview"
              spy={true}
              smooth={true}
              offset={-100}
            >
              Overview
            </S.LinkWithHref>
            {!isTreezPage && (
              <S.LinkWithHref
                activeClass="active"
                url="/#examples"
                spy={true}
                smooth={true}
                offset={-100}
              >
                Examples
              </S.LinkWithHref>
            )}
            {isTreezPage && (
              <S.LinkWithHref
                activeClass="active"
                url="/#benefits"
                spy={true}
                smooth={true}
                offset={-100}
              >
                Benefits
              </S.LinkWithHref>
            )}
            <S.LinkWithHref
              activeClass="active"
              url="/#testimonials"
              spy={true}
              smooth={true}
              offset={-100}
            >
              Testimonials
            </S.LinkWithHref>
            {!isTreezPage && (
              <S.LinkWithHref
                activeClass="active"
                url="/#our-mission"
                spy={true}
                smooth={true}
                offset={-100}
              >
                Our Mission
              </S.LinkWithHref>
            )}
            <S.LinkWithHref
              activeClass="active"
              url="/#blog"
              spy={true}
              smooth={true}
              offset={-100}
            >
              Blog
            </S.LinkWithHref>
          </S.NavItems>
        )}
        {!isTreezPage && (
          <CustomButton className="green" href="/book-a-demo" disableRipple>
            Book a Demo
          </CustomButton>
        )}
        {isTreezPage && (
          <CustomButton
            className="green"
            onClick={() => {
              setIsFormDrawerOpen(true)
            }}
            disableRipple
          >
            Book a Demo
          </CustomButton>
        )}
      </S.CustomContainer>
    </S.CustomAppBar>
  )
}
export default Header
